import { render, staticRenderFns } from "./CustomTableReport.vue?vue&type=template&id=f8534e6c&"
import script from "./CustomTableReport.vue?vue&type=script&lang=js&"
export * from "./CustomTableReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports